<template>
  <Modal
    v-model="_value"
    width="750"
    title="导出安装证明"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="content"
             ref="table"
             @on-sort-change="sortChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Modal v-model="setPDFDatetimeModal" title="PDF文档证明时间" @on-ok="onPDFOk" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setDatetimeModal" title="WORD文档证明时间" @on-ok="onOk" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setPDFVideoDatetimeModal" title="PDF文档视频机证明时间" @on-ok="onPDFOkVideo" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setVideoDatetimeModal" title="视频机证明时间" @on-ok="onOkVideo" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setCommitmentModal" title="导出智能视频报警装置安装承诺函" @on-ok="onOkCommitment" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
        <Form-item label="单位">
          <Select style="width: 200px;" v-model="governmentAgency">
            <Option v-if="certificateArea == 1" v-for="item in zsgovernmentAgencyOptions" :value="item.label" :key="item.value">{{item.label}}</Option>
            <Option v-else v-for="item in jmgovernmentAgencyOptions" :value="item.label" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setPDFMergencyAlarmModal" title="导出应急报警装置安装证明" @on-ok="onPDFOkMergencyAlarm" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setMergencyAlarmModal" title="导出应急报警装置安装证明" @on-ok="onOkMergencyAlarm" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setInsuranceVideoCommitment" title="导出保险行业安装承诺函" @on-ok="onOkInsuranceVideoCommitment" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="设备厂商">
          <Select style="display: inline-block; width: 200px;" v-model="manufacturer">
            <Option v-for="item in manufacturerpubTypeOptions" :value="item.value" :key="item.value">{{item.name}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item>
          <Checkbox size="small" style="margin-left: 60px;" v-model="isall">是否导出完整文档</Checkbox>
        </Form-item>
<!--        <Form-item label="打印日期">-->
<!--          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"-->
<!--                      v-model="exportDatetime"></DatePicker>-->
<!--        </Form-item>-->
      </Form>
    </Modal>
    <Modal v-model="setStarLightAlarm" title="导出声光报警盲区证明" @on-ok="onOkStarLightAlarm" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
      </Form>
    </Modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'exportvehiclecertmodal',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    installed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

      certificateAreaOptions: [
        { label: '中山', value: 1 },
        { label: '江门', value: 2 }
      ],

      governmentAgency: null,

      zsgovernmentAgencyOptions: [
        { label: '中山市交通运输局', value: 1 }
      ],

      jmgovernmentAgencyOptions: [
        { label: '江门市交通运输局', value: 1 },
        { label: '台山市交通运输局', value: 2 },
        { label: '鹤山市交通运输局', value: 3 },
        { label: '恩平市交通运输局', value: 4 },
        { label: '开平市交通运输局', value: 5 }
      ],

      // 设置时间
      setDatetimeId: null,
      setPDFDatetimeModal: false,
      setDatetimeModal: false,
      setPDFVideoDatetimeModal: false,
      setVideoDatetimeModal: false,
      installDatetime: null,
      exportDatetime: null,
      adas: false,
      certificateArea: 1,
      isall: false,
      manufacturer: 1,

      manufacturerpubTypeOptions: [
        { name: '深圳市锐明技术股份有限公司', value: 1 },
        { name: '江苏市中天安驰科技有限公司', value: 2 }
      ],

      // 承诺函
      setCommitmentModal: false,

      // 应急报警装置安装证明
      setPDFMergencyAlarmModal: false,
      setMergencyAlarmModal: false,

      // 保险行业安装承诺函
      setInsuranceVideoCommitment: false,

      //声光报警盲区证明
      setStarLightAlarm: false,

      modify: false,
      positioningDeviceInfoDetailModal: false,
      positioningDeviceInfoDetailId: null,
      searchPositioningDeviceInfoList: [],
      searchPositioningDeviceInfoLoading: false,
      selectPositioningDeviceInfos: [],
      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      // positioningDeviceModelOptions: [
      //   { label: 'BSJ-A6-BD', value: 1 },
      //   { label: 'BSJ-GF03', value: 2 },
      //   { label: 'BSJ-M11', value: 3 },
      //   { label: 'BSJ-A6L', value: 13 },
      //   { label: 'BSJ-A7', value: 14 },
      //   { label: 'K5', value: 4 },
      //   { label: 'D5X', value: 5 },
      //   { label: 'G-3G', value: 6 },
      //   { label: 'D5X-HDD', value: 7 },
      //   { label: 'D5X-XR', value: 8 },
      //   { label: 'BSJ-GF06', value: 9 },
      //   { label: 'BSJ-RM01', value: 10 },
      //   { label: 'HIK-A3', value: 11 },
      //   { label: 'HIK-A3L', value: 12 }
      // ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        positioningDeviceModelId: null,
        sourceType: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null
      },
      listLoadding: false,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 70
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          minWidth: 100
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            if (params.row.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            } else {
              return h('div', '未知')
            }
            // let positioningDeviceModel = params.row.positioningDeviceModelId
            // if (positioningDeviceModel === 1) {
            //   return h('div', 'BSJ-A6-BD')
            // } else if (positioningDeviceModel === 2) {
            //   return h('div', 'BSJ-GF03')
            // } else if (positioningDeviceModel === 3) {
            //   return h('div', 'BSJ-M11')
            // } else if (positioningDeviceModel === 13) {
            //   return h('div', 'BSJ-A6L')
            // } else if (positioningDeviceModel === 14) {
            //   return h('div', 'BSJ-A7')
            // } else if (positioningDeviceModel === 4) {
            //   return h('div', 'K5')
            // } else if (positioningDeviceModel === 5) {
            //   return h('div', 'D5X')
            // } else if (positioningDeviceModel === 6) {
            //   return h('div', 'G-3G')
            // } else if (positioningDeviceModel === 7) {
            //   return h('div', 'D5X-HDD')
            // } else if (positioningDeviceModel === 8) {
            //   return h('div', 'D5X-XR')
            // } else if (positioningDeviceModel === 9) {
            //   return h('div', 'BSJ-GF06')
            // } else if (positioningDeviceModel === 10) {
            //   return h('div', 'BSJ-RM01')
            // } else if (positioningDeviceModel === 11) {
            //   return h('div', 'HIK-A3')
            // } else if (positioningDeviceModel === 12) {
            //   return h('div', 'HIK-A3L')
            // } else {
            //   return h('div', '未知')
            // }
          }
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          minWidth: 80,
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 260,
          render: (h, params) => {
            let display = []
            display.push(
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small',
              //     disabled: false
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.setDatetimeId = params.row.id
              //       this.exportDatetime = new Date()
              //       if (params.row.setupDatetime) {
              //         this.installDatetime = new Date(params.row.setupDatetime)
              //       } else {
              //         this.installDatetime = new Date()
              //       }
              //       this.setDatetimeModal = true
              //     }
              //   }
              // }, '导出证明')
              h('Dropdown', {
                props: {
                  trigger: 'click',
                  transfer: true
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  // "on-click": value => {
                  //   if (value === "edit") {
                  //     this.$store.commit("fsfs/edit", params.row);
                  //     this.edit();
                  //   } else if (value === "delete") {
                  //     console.log("点击了删除");
                  //   }
                  // }
                }
              },
              [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    }
                  },
                  [
                    h('span', '导出证明'),
                    h('Icon', {
                      props: {
                        type: 'ios-cog',
                        size: 18
                      }
                    })
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setDatetimeId = params.row.id
                          this.exportDatetime = new Date()
                          if (params.row.setupDatetime) {
                            this.installDatetime = new Date(params.row.setupDatetime)
                          } else {
                            this.installDatetime = new Date()
                          }
                          this.setPDFDatetimeModal = true
                        }
                      }
                    }, '导出pdf文档')
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setDatetimeId = params.row.id
                          this.exportDatetime = new Date()
                          if (params.row.setupDatetime) {
                            this.installDatetime = new Date(params.row.setupDatetime)
                          } else {
                            this.installDatetime = new Date()
                          }
                          this.setDatetimeModal = true
                        }
                      }
                    }, '导出word文档')
                  ]
                )
              ]
              )
            )
            if (params.row.positioningDeviceModel.adas) {
              display.push(
                // h('Button', {
                //   props: {
                //     type: 'primary',
                //     size: 'small',
                //     disabled: false
                //   },
                //   style: {
                //     marginRight: '5px'
                //   },
                //   on: {
                //     click: () => {
                //       this.setDatetimeId = params.row.id
                //       this.exportDatetime = new Date()
                //       if (params.row.setupDatetime) {
                //         this.installDatetime = new Date(params.row.setupDatetime)
                //       } else {
                //         this.installDatetime = new Date()
                //       }
                //       this.setVideoDatetimeModal = true
                //       this.adas = params.row.positioningDeviceModel.adas
                //     }
                //   }
                // }, '导出视频机证明')
                h('Dropdown', {
                  props: {
                    trigger: 'click',
                    transfer: true
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    // "on-click": value => {
                    //   if (value === "edit") {
                    //     this.$store.commit("fsfs/edit", params.row);
                    //     this.edit();
                    //   } else if (value === "delete") {
                    //     console.log("点击了删除");
                    //   }
                    // }
                  }
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      }
                    },
                    [
                      h('span', '导出视频证明'),
                      h('Icon', {
                        props: {
                          type: 'ios-cog',
                          size: 18
                        }
                      })
                    ]
                  ),
                  h(
                    'DropdownMenu',
                    {
                      slot: 'list'
                    },
                    [
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.setDatetimeId = params.row.id
                            this.exportDatetime = new Date()
                            if (params.row.setupDatetime) {
                              this.installDatetime = new Date(params.row.setupDatetime)
                            } else {
                              this.installDatetime = new Date()
                            }
                            this.setPDFVideoDatetimeModal = true
                            this.adas = params.row.positioningDeviceModel.adas
                          }
                        }
                      }, '导出pdf文档')
                    ]
                  ),
                  h(
                    'DropdownMenu',
                    {
                      slot: 'list'
                    },
                    [
                      h('DropdownItem', {
                        props: {
                          type: 'primary',
                          size: 'small',
                          disabled: false
                        },
                        style: {
                          marginRight: '5px'
                        },
                        nativeOn: {
                          click: () => {
                            this.setDatetimeId = params.row.id
                            this.exportDatetime = new Date()
                            if (params.row.setupDatetime) {
                              this.installDatetime = new Date(params.row.setupDatetime)
                            } else {
                              this.installDatetime = new Date()
                            }
                            this.setVideoDatetimeModal = true
                            this.adas = params.row.positioningDeviceModel.adas
                          }
                        }
                      }, '导出word文档')
                    ]
                  )
                ]
                )
              )
            }
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.setDatetimeId = params.row.id
            //         this.setCommitmentModal = true
            //       }
            //     }
            //   }, '导出承诺函')
            // )
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.setDatetimeId = params.row.id
            //         this.exportDatetime = new Date()
            //         if (params.row.setupDatetime) {
            //           this.installDatetime = new Date(params.row.setupDatetime)
            //         } else {
            //           this.installDatetime = new Date()
            //         }
            //         this.setMergencyAlarmModal = true
            //       }
            //     }
            //   }, '导出应急报警证明')
            // )

            display.push(
              h('Dropdown', {
                props: {
                  trigger: 'click',
                  transfer: true
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  // "on-click": value => {
                  //   if (value === "edit") {
                  //     this.$store.commit("fsfs/edit", params.row);
                  //     this.edit();
                  //   } else if (value === "delete") {
                  //     console.log("点击了删除");
                  //   }
                  // }
                }
              },
              [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    }
                  },
                  [
                    h('span', '其他'),
                    h('Icon', {
                      props: {
                        type: 'ios-cog',
                        size: 18
                      }
                    })
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setDatetimeId = params.row.id
                          this.exportDatetime = new Date()
                          if (params.row.setupDatetime) {
                            this.installDatetime = new Date(params.row.setupDatetime)
                          } else {
                            this.installDatetime = new Date()
                          }
                          this.setCommitmentModal = true
                        }
                      }
                    }, '导出承诺函')
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setDatetimeId = params.row.id
                          this.exportDatetime = new Date()
                          if (params.row.setupDatetime) {
                            this.installDatetime = new Date(params.row.setupDatetime)
                          } else {
                            this.installDatetime = new Date()
                          }
                          this.setInsuranceVideoCommitment = true
                        }
                      }
                    }, '导出保险承诺函')
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setDatetimeId = params.row.id
                          this.exportDatetime = new Date()
                          if (params.row.setupDatetime) {
                            this.installDatetime = new Date(params.row.setupDatetime)
                          } else {
                            this.installDatetime = new Date()
                          }
                          this.setPDFMergencyAlarmModal = true
                        }
                      }
                    }, '导出应急报警证明pdf文档')
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setDatetimeId = params.row.id
                          this.exportDatetime = new Date()
                          if (params.row.setupDatetime) {
                            this.installDatetime = new Date(params.row.setupDatetime)
                          } else {
                            this.installDatetime = new Date()
                          }
                          this.setMergencyAlarmModal = true
                        }
                      }
                    }, '导出应急报警证明word文档')
                  ]
                ),
                h(
                  'DropdownMenu',
                  {
                    slot: 'list'
                  },
                  [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.setDatetimeId = params.row.id
                          this.setStarLightAlarm = true
                        }
                      }
                    }, '导出声光报警盲区证明pdf文档')
                  ]
                )
              ]
              )
            )

            return h('div', display)
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj',
      'VehicleInfoServ_BindPositioningDeviceInfos',
      'VehicleInfoServ_UnBindPositioningDeviceInfos',
      'PositioningDeviceInfoServ_GetAll'
    ]),
    onPDFOk () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 2
      window.location.href = '/api/im/positioningdeviceinfo/generatecertificateforyiliu/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
    },
    onOk () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 2
      window.location.href = '/api/im/positioningdeviceinfo/generatecertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
    },
    onPDFOkVideo () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 2
      let adas = this.adas
      window.location.href = '/api/im/positioningdeviceinfo/generatevideocertificateforyiliu/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType + '/' + adas
    },
    onOkVideo () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 2
      let adas = this.adas
      window.location.href = '/api/im/positioningdeviceinfo/generatevideocertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType + '/' + adas
    },
    onOkCommitment () {
      // console.log(this.governmentAgency)
      if (this.governmentAgency == null) {
        this.$Message.error('请选择政府单位')
      } else {
        let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
        let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
        window.location.href = '/api/im/positioningdeviceinfo/generatevideocommitment/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + this.governmentAgency
      }
    },
    onPDFOkMergencyAlarm () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 2
      if (this.certificateArea == 2) {
        window.location.href = '/api/im/positioningdeviceinfo/generateemergencyalarmcertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
      } else {
        window.location.href = '/api/im/positioningdeviceinfo/generateemergencyalarmcertificateforyiliu/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
      }
    },
    onOkMergencyAlarm () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 2
      if (this.certificateArea == 2) {
        window.location.href = '/api/im/positioningdeviceinfo/generateemergencyalarmcertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
      } else {
        window.location.href = '/api/im/positioningdeviceinfo/generateemergencyalarmcertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
      }
    },
    onOkInsuranceVideoCommitment () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 2
      window.location.href = '/api/im/positioningdeviceinfo/generateinsurancevideocommitment/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType + '/' + this.isall + '/' + this.manufacturer
    },
    onOkStarLightAlarm () {
      window.location.href = '/api/im/positioningdeviceinfo/generatestarlightalarmforyiliu/' + this.setDatetimeId + '/' + this.certificateArea
    },
    onBindPositioningDeviceInfos () {
      this.$Modal.confirm({
        title: '确认绑定设备',
        content: '<p>确认绑定设备</p>',
        onOk: () => {
          store.dispatch('VehicleInfoServ_BindPositioningDeviceInfos', {
            params: { id: this._initValue, positioningDeviceInfoIds: this.selectPositioningDeviceInfos }
          }).then(() => {
            this.$Message.success('修改成功')
            this.updateTable()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    searchPositioningDeviceInfo (input) {
      this.searchPositioningDeviceInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchPositioningDeviceInfoList = []
        this.searchPositioningDeviceInfoLoading = false
      } else {
        store.dispatch('PositioningDeviceInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchPositioningDeviceInfoList = store.getters.get_PositioningDeviceInfo_SearchByNameResult ? store.getters.get_PositioningDeviceInfo_SearchByNameResult : []
          this.searchPositioningDeviceInfoLoading = false
        }).catch(err => {
          this.searchPositioningDeviceInfoLoading = false
        })
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    updateTable () {
      this.listLoadding = true
      let queryParams = []
      let sortParam = null
      queryParams.push(genQueryParam('vehicleInfoId', 'EQ', this._initValue))
      store.dispatch('PositioningDeviceInfoServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams,
          keyword: null,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        this.searchPositioningDeviceInfoList = []
        this.selectPositioningDeviceInfos = []
        this.listLoadding = true
        let queryParams = []
        let sortParam = null
        if (this.installed) {
          queryParams.push(genQueryParam('vehicleInfoId', 'EQ', this._initValue))
        } else {
          queryParams.push(genQueryParam('installOrderId', 'EQ', this._initValue))
        }
        store.dispatch('PositioningDeviceInfoServ_GetAll', {
          params: null,
          urlparams: {
            q: queryParams,
            keyword: null,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    content () {
      if (store.getters.get_PositioningDeviceInfo_GetAllResult) {
        return store.getters.get_PositioningDeviceInfo_GetAllResult
      } else {
        return []
      }
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _installed: {
      get () {
        return this.installed
      },
      set (val) {
        // this.$emit('input', val)
        // this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
